<app-menu-template3>
  <form class="mr-5 ml-5 mt-3 mb-3" [formGroup]="completaForm" (ngSubmit)="onUpdate()">
    <main class="container-12">
      <article class="row ml-5 mr-5 mt-2 mb-3 rounded shadow bg-white">

        <header class="col-sm-12 col-md-3 text-center otras-solicitudes-bg">
          <header>
            <label *ngIf="dataShared.data.tipo_rnt_id === tipo_guia" class="h5 text-white mb-5">Guía de turismo</label>
            <label *ngIf="dataShared.data.tipo_rnt_id === tipo_establecimiento"
              class="h5 text-white mb-5">Establecimiento</label>
            <label *ngIf="dataShared.data.tipo_rnt_id === tipo_inmueble" class="h5 text-white mb-5">Inmueble</label>
          </header>
          <section class="row pl-3 text-white">
            <div class="col-sm-4 col-md-12 text-left">
              <label class="small">Nombre</label>
              <p class="h5">{{dataShared.data.razon_social}}</p>
            </div>
            <div class="col-sm-4 col-md-12 text-left">
              <label class="small">Número RNT</label>
              <p class="h5">{{dataShared.data.codigo_rnt}}</p>
            </div>
            <div class="col-sm-4 col-md-12 text-left">
              <label class="small">Cámara de comercio</label>
              <p class="h5">{{dataShared.data.descripcion_camara}}</p>
            </div>
            <div class="col-sm-4 col-md-12 text-left">
              <label class="small">Sub categoría</label>
              <p class="h5">{{dataShared.data.descripcion_tipo_establecimiento}}</p>
            </div>
          </section>
          <section *ngIf="dataShared.tipo_solicitud == tipo_reactivacion" class="mt-4">
            <ul class="nav flex-column">
              <li class="nav-item" *ngFor="let item of totalPasos; let i=index">
                <label class="nav-link otras-solicitudes-pasos" [ngClass]="{'otras-solicitudes-pasos-active': pasoActual === (i+1)}">
                  <i class="otras-solicitudes-pasos-circulo mr-2"></i>
                  Paso {{i+1}}
                </label>
              </li>
            </ul>
          </section>
        </header>
        <section class="col">
          <div class="mr-5 ml-5 mt-5 mb-3">

            <app-ayudas [ayuda]="ayudaService.otrasSolicitudes(
              dataShared.tipo_solicitud,
              dataShared.tipo_rnt,
              dataShared.data.estado_rnt_id,
              dataShared.data.estado_solicitud_id,
              dataShared.data.sub_categoria_id
              )">
            </app-ayudas>
            <section class="row border-bottom">

              <header class="row form-group d-flex align-items-center">
                <figure class="col-3 m-auto">
                  <img src="/assets/icons/otras-solicitudes.png" class="d-inline-block p-2 rounded-circle" alt=""
                    height="60">
                </figure>
                <div class="col row">
                  <label class="small text-muted mb-0 ml-4">Tipo de solicitud<br><strong class="h5 text-body"
                      *ngIf="dataShared.tipo_solicitud == tipo_cancelacion">Cancelación</strong>
                    <div *ngIf="dataShared.tipo_solicitud === tipo_reactivacion">
                      <strong class="h5 text-body" *ngIf="dataShared.data.estado_rnt_id === estado_suspendido_por_no_renovar">
                        Reactivación+renovación
                      </strong>
                      <strong class="h5 text-body" *ngIf="dataShared.data.estado_rnt_id !== estado_suspendido_por_no_renovar">
                        Reactivación
                      </strong>
                    </div>
                    <strong class="h5 text-body"
                      *ngIf="dataShared.tipo_solicitud === tipo_suspencion">Suspensión</strong></label>

                </div>
              </header>
            </section>
            <!-- <section class="row border-bottom pt-4 pb-4"> -->
            <section>
              <header class="col-sm-12 col-md">
                <p class="text-muted" *ngIf="dataShared.tipo_solicitud === tipo_cancelacion">
                  Diligencie el motivo de cancelación. Recuerde que esta acción es definitiva y no tendrá la
                  posibilidad de realizar ningún cambio posterior en este RNT.
                </p>
                <p class="text-muted" *ngIf="dataShared.tipo_solicitud === tipo_suspencion">
                  Ingrese la fecha de inicio y finalización de la suspensión, la cual no debe ser superior a un año.
                </p>
                <div *ngIf="dataShared.tipo_solicitud === tipo_reactivacion">
                  <br />
                  <p
                  [ngClass]="{
                    'text-muted': valorFormaPagoFontur === this.paga_manual
                  }"
                    [innerHTML]="Texto_Reactivacion_renovacion1"
                    [ngStyle]="{
                      'font-weight': result_pago_fontur?.estado_pago_fontur_id === 1 && valorFormaPagoFontur!==this.paga_manual ? 'bold' : 'normal',
                      'color': getColor(result_pago_fontur?.estado_pago_fontur_id),
                      'font-size.px': isPaymentStatusValid(result_pago_fontur?.estado_pago_fontur_id) ? 20 : 16
                    }"
                  ></p>
                </div>
                  <!--inicio reactivacion fin -->
              </header>
            </section>
            <section class="row border-bottom pt-4 pb-4">
              <aside class="col-sm-12 col-md-4 pr-5" *ngIf="dataShared.tipo_solicitud === tipo_suspencion">
                <header>
                  <h2 class="h6 mb-4 font-weight-bold">Periodo suspensión</h2>
                </header>
                <footer>
                  <div class="mb-2">
                    <label class="text-secondary small mb-0">Fecha inicio suspensión</label>
                    <div class="input-group">
                      <input class="form-control form-control-sm" formControlName="fecha_inicio_suspension"
                        placeholder="yyyy/mm/dd" ngbDatepicker #inicio="ngbDatepicker" readonly disabled>
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="inicio.toggle()"
                          type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="text-secondary small mb-0">Fecha fin suspensión</label>
                    <div class="input-group">
                      <input class="form-control form-control-sm" formControlName="fecha_fin_suspension"
                        placeholder="yyyy/mm/dd" ngbDatepicker #fin="ngbDatepicker" [minDate]="calendar.getToday()"
                        readonly [maxDate]="maxDateValidation">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()"
                          type="button"></button>
                      </div>
                    </div>
                  </div>
                </footer>
              </aside>
              <ng-container *ngIf="dataShared.tipo_solicitud !== tipo_reactivacion ; else otraSolicitud">
                <section class="col pl-4 pr-4">
                  <header>
                    <h2 class="h6 mb-4 font-weight-bold" *ngIf="dataShared.tipo_solicitud == tipo_suspencion">Motivo de
                      Suspensión</h2>
                    <h2 class="h6 mb-4 font-weight-bold" *ngIf="dataShared.tipo_solicitud == tipo_cancelacion">Motivo
                      de Cancelación</h2>
                    <h2 class="h6 mb-4 font-weight-bold" *ngIf="dataShared.tipo_solicitud == tipo_reactivacion">Motivo
                      de Reactivación</h2>
                  </header>
                  <textarea formControlName="observaciones" class="h-75 w-100 form-control"></textarea>
                </section>
              </ng-container>
              <ng-template #otraSolicitud>
                <div *ngIf="valorFormaPagoFontur===this.paga_manual">
                  <section class="col pl-4 pr-4">
                    <header>
                      <h2 class="h6 mb-4 font-weight-bold">Motivo de Reactivación: Diligenciar número de recibo, monto,
                        fecha y hora</h2>
                    </header>
                    <textarea formControlName="observaciones" class="w-100 form-control mb-2"></textarea>
                    <header>
                      <h2 class="h6 mb-4 font-weight-bold">Adjuntar archivo</h2>
                    </header>
                    <ng-container *ngIf="datos_adjuntos; else no_data">
                      <app-tablas [headers]="headers" [sizeData]="datos_adjuntos ? datos_adjuntos.length : 0">
                        <tr *ngFor="let item of datos_adjuntos">

                          <td>{{item.nombre}}</td>
                          <td>
                            <ng-container *ngIf="item.porcentaje_cargado === 100; else upload">
                              <a class="btn" [routerLink]="null">
                                <img src="../../../../../../../assets/icons/doc.png" class="img-fluid w-50"
                                  (click)="onVerDocumento(item)">
                              </a>
                              <a class="btn" [routerLink]="null">
                                <img src="../../../../../../../assets/icons/delete.png" class="img-fluid w-50"
                                  (click)="onRemoverFile(item)">
                              </a>
                            </ng-container>
                            <ng-template #upload>
                              <ngb-progressbar type="info" [value]="item.porcentaje_cargado" [striped]="true"
                                [animated]="true"><i>{{item.porcentaje_cargado}}%</i></ngb-progressbar>
                            </ng-template>
                          </td>
                        </tr>
                      </app-tablas>
                      <a [routerLink]="null" class="btn btn-success" (click)="adjuntar.click()"
                        *ngIf="!datos_adjuntos || datos_adjuntos.length === 0">Adjuntar</a>
                      <!--Agregar más archivos-->
                      <input #adjuntar type="file" [hidden]="true" (change)="onFileInput($event)"
                        [accept]="extensiones" />
                    </ng-container>
                    <ng-template #no_data>
                      <footer class="row text-center justify-content-center">
                        <figure class="figure">
                          <img class="img-fluid mb-4 w-50"
                            src="../../../../../../../assets/images/sin_establecimiento.png" />
                          <figcaption>
                            <p class="text-muted">Una vez el pago ha sido realizado, debes adjuntar un archivo del recibo
                              de pago</p>
                            <a class="btn btn-outline-primary" (click)="adjuntar.click()">Adjuntar</a>
                            <input #adjuntar type="file" [hidden]="true" (change)="onFileInput($event)"
                              [accept]="extensiones" />
                          </figcaption>
                        </figure>
                      </footer>
                    </ng-template>
                  </section>
                </div>
              </ng-template>
            </section>
            <section class="col-12 text-right">

              <button class="btn btn-primary m-3" type="submit" [disabled]="!completaForm.valid"
                *ngIf="dataShared.tipo_solicitud !== tipo_reactivacion">Enviar</button>

              <button class="btn btn-primary m-3" type="submit"
                      [disabled]="!completaForm.valid || ((!datos_adjuntos || datos_adjuntos.length <= 0))"
                      *ngIf="dataShared.tipo_solicitud == tipo_reactivacion
                        && dataShared.data.estado_rnt_id !== estado_suspendido_por_no_renovar
                        && !omitir_documentos">Enviar</button>

              <button class="btn btn-primary m-3" type="submit"
                      [disabled]="!completaForm.valid"
                      *ngIf="dataShared.tipo_solicitud == tipo_reactivacion
                        && dataShared.data.estado_rnt_id !== estado_suspendido_por_no_renovar
                        && omitir_documentos">Enviar</button>

              <!-- Condición 1: Activar y visualizar cuando estado_pago_fontur_id == 1 -->
              <button class="btn btn-primary m-3" type="submit"
                      [disabled]="false"
                      *ngIf="result_pago_fontur?.estado_pago_fontur_id == 1 && valorFormaPagoFontur!==this.paga_manual
                        && dataShared.tipo_solicitud == tipo_reactivacion
                        && dataShared.data.estado_rnt_id === estado_suspendido_por_no_renovar
                        && !omitir_documentos">Continuar</button>

              <!-- Condición 2: Visualizar pero deshabilitado cuando estado_pago_fontur_id == 2 -->
              <button class="btn btn-primary m-3" type="submit"
                      [disabled]="true"
                      *ngIf="result_pago_fontur?.estado_pago_fontur_id == 2
                        && dataShared.tipo_solicitud == tipo_reactivacion
                        && dataShared.data.estado_rnt_id === estado_suspendido_por_no_renovar
                        && !omitir_documentos">Continuar</button>

              <!-- Condición 3: Activar y visualizar con completaForm cuando estado_pago_fontur_id == 3 -->
              <button class="btn btn-primary m-3" type="submit"
                      [disabled]="!completaForm.valid || ((!datos_adjuntos || datos_adjuntos.length <= 0))"
                      *ngIf="valorFormaPagoFontur===this.paga_manual
                        && dataShared.tipo_solicitud == tipo_reactivacion
                        && dataShared.data.estado_rnt_id === estado_suspendido_por_no_renovar
                        && !omitir_documentos">Continuar</button>

            </section>
          </div>
        </section>
      </article>
    </main>
  </form>
</app-menu-template3>
